import { isValidDateLike, isValidPositiveInteger } from '@utriper/core';
import { fetch, Method } from 'core/api/fetch';
import { parseAvailability } from '../parser/availability';

const AvailabilityRoutes = {
    getAvailability: (experienceId, params) => `/api/v2.0/experiences/${experienceId}/availability?${params}`,
};

export const AvailabilityService = {
    getAvailability: async ({ experienceId, experienceDetailId, fromDateTime, toDateTime, units = [], resources = [], code, targetCurrency = null }) => {
        try {
            const params = new URLSearchParams();

            if (isValidPositiveInteger(experienceDetailId)) {
                params.append('experienceDetailId', experienceDetailId);
            }

            if (isValidDateLike(fromDateTime)) {
                params.append('fromDateTime', fromDateTime.toISOString());
            }

            if (isValidDateLike(toDateTime)) {
                params.append('toDateTime', toDateTime.toISOString());
            }

            if (Array.isArray(units) && units?.length > 0) {
                const unitsParsed = units.filter((unit) => isValidPositiveInteger(unit?.quantity)).map((unit) => ({ quantity: unit?.quantity, unitId: unit?.unitId ?? unit?.id }));
                params.append('units', JSON.stringify(unitsParsed));
            }

            if (Array.isArray(resources) && resources?.length > 0) {
                params.append('resources', JSON.stringify(resources));
            }

            if (typeof code === 'string' && code.length > 0) {
                params.append('code', code);
            }

            if (typeof targetCurrency === 'string' && targetCurrency?.length > 0) {
                params.append('targetCurrency', targetCurrency);
            }

            const { data } = await fetch(AvailabilityRoutes.getAvailability(experienceId, params.toString()), {
                method: Method.GET,
                authenticated: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return Array.isArray(data) ? data.map(parseAvailability) : [];
        } catch (error) {
            console.error(error);
        }
    },
};
